
import { createApp } from 'vue'
import App from './App.vue'
import 'vant/lib/index.css'; // 引入 Vant 的样式文件
import vant from 'vant'
import axios from 'axios';
import router from './router'


const app = createApp(App);
app.use(vant)
app.use(router)
const http = axios.create({
    baseURL: "https://xxyx.xuxug.com",
    timeout: 50000,
});
app.config.globalProperties.$http = http;
app.config.globalProperties.$getLoginInfo = function(){
    var yonghuxinxi = localStorage.getItem('userinfo');
    if(yonghuxinxi != null && yonghuxinxi != '')
    {
        return yonghuxinxi;
    }
    else
    {
        return "";
    }
};
app.mount('#app');